import { ReporteCompensacionesComponent } from './reporte-compensaciones.component';
import { ReporteCompensacionesRouting } from './reporte-compensaciones-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { PlanCompensatorioModule } from '../plan-compensatorio.module';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/formulario/', '.json');
}
@NgModule({
    declarations: [ReporteCompensacionesComponent],
    imports: [
        ReporteCompensacionesRouting,
        PlanCompensatorioModule,
        SharedModule,
        CommonModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            isolate: true
        })
    ],
    entryComponents: []
})
export class ReporteCompensacionesModule { }
